import Sortable from 'sortablejs';
import { getElements } from 'js-utils/src/selector';

import init from '../../common/base/init';

init(() => {
  const lists = getElements('.js--sortable');
  if(!lists.length) return;

  lists.forEach((list) => {
    Sortable.create(list, {
      handle: '.sortable-handle',
      dataIdAttr: 'data-attribute-name',
      group: 'saved-searches',
      store: {
        get: function (sortable) {
          var order = localStorage.getItem(sortable.options.group.name);
          return order ? order.split('|') : [];
        },
        set: function (sortable) {
          var order = sortable.toArray();
          localStorage.setItem(sortable.options.group.name, order.join('|'));
        },
      },
    });
  });
});
